// Solana Program IDs
export const PROGRAM_IDS = {
  // System Program
  SYSTEM: '11111111111111111111111111111111',

  // Token Programs
  TOKEN: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
  TOKEN_2022: 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb',
  ASSOCIATED_TOKEN: 'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL',
} as const

// Common Solana addresses
export const ADDRESSES = {
  // Wrapped SOL mint
  WSOL_MINT: 'So11111111111111111111111111111111111111112',
} as const

// Instruction discriminators for common operations
export const INSTRUCTION_DISCRIMINATORS = {
  // Raydium
  RAYDIUM_SWAP: [248, 198, 158, 145, 225, 117, 135, 200],
  RAYDIUM_ADD_LIQUIDITY: [181, 157, 89, 67, 143, 182, 52, 72],
  RAYDIUM_REMOVE_LIQUIDITY: [80, 85, 209, 72, 24, 206, 177, 108],

  // Jupiter
  JUPITER_ROUTE: [229, 23, 203, 151, 122, 227, 173, 42],
  JUPITER_EXACT_OUT: [67, 167, 211, 90, 139, 91, 84, 65],

  // Token Program
  TOKEN_TRANSFER: [3],
  TOKEN_TRANSFER_CHECKED: [12],
  TOKEN_MINT_TO: [7],
  TOKEN_BURN: [8],
} as const

// Common Solana transaction errors
export const TRANSACTION_ERRORS = {
  INSUFFICIENT_FUNDS: 'InsufficientFunds',
  ACCOUNT_NOT_FOUND: 'AccountNotFound',
  INVALID_PROGRAM_FOR_EXECUTION: 'InvalidProgramForExecution',
  CUSTOM_ERROR: 'Custom',
} as const

export const nativeTokenDecimals = 9

export const nativeAsset = {
  symbol: 'SOL',
  type: 'CryptoCurrency',
  id: 'solana',
  name: 'Solana',
  updatedAt: 0,
} as const
